import { render } from "./CreateBankDetails.vue?vue&type=template&id=5478a71c"
import script from "./CreateBankDetails.vue?vue&type=script&lang=js"
export * from "./CreateBankDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__